export default {
  dataProjection: 'EPSG:4326',
  featureProjection: 'EPSG:3857',
};
